import { translateSchema } from '../../../../../i18n/translateHelper';
export const generateSchema = () => {
  const schema = {
    title: 'customFlow:finalEmailModal',
    type: 'object',
    properties: {
      emails: {
        title: 'Emails',
        type: 'array',
        items: {
          type: 'string',
          format: 'email'
        }
      }
    } };

  const translatedSchema = translateSchema(schema);
  return translatedSchema;
};
